import * as React from "react";
import { Button } from "@blueprintjs/core";
import { StoresContext } from "../../pages/_app";
import { useContext, useState } from "react";

interface AnnotationDownloadButtonProps {
  disabled: boolean;
  genomeName: string;
  genomeUuid?: string;
  searchTerm: string;
  annotationUuids: string[];
  assemblyUuid?: string;
  hasRequiredSubscription?: () => boolean;
}

const AnnotationDownloadButton = (props: AnnotationDownloadButtonProps) => {
  const rootStore = useContext(StoresContext);
  const [disabled, setDisabled] = useState<boolean>(props.disabled);

  const onClick = () => {
    setDisabled(true);
    rootStore.userStore.tryToDoGuardedAction(
      async () => {
        const message = await rootStore.genomeStore.downloadAnnotationsCSV(
          props.genomeName,
          props.searchTerm,
          props.annotationUuids,
          rootStore.userStore.getUserEmail(),
          props.genomeUuid,
          props.assemblyUuid
        );
        setDisabled(props.disabled);
        return message;
      },
      false,
      props.hasRequiredSubscription
    );
  };

  return (
    <div className="annotation-download">
      <Button onClick={onClick} disabled={disabled}>
        Download Table CSV
      </Button>
    </div>
  );
};

export default AnnotationDownloadButton;
